module.exports = __webpack_public_path__ + "static/media/coin-white.dc231766.svg";